import { Injectable } from '@angular/core';
import { ActionCardStrategy } from '../action-card.interface';

@Injectable()
export class UnauthorizedStrategy extends ActionCardStrategy {
  imgSrc = 'alert.svg';
  imgMode = 'light' as const;
  title = 'expired-dialog.your-session-expired';
  description = 'expired-dialog.please-sign-in-again-to-continue-using-the-app';
  buttonLabel = 'expired-dialog.sign-in';
  cardClassName = 'action-card--unauthorized';
  severity = 'default' as const;
  uploadButtonImgSrc = undefined;
  uploadButtonImgMode = undefined;
}
